export default {
  id: 'vehicle.createdOn',
  name: 'vehicle.createdOn',
  displayName: 'Created On',
  valueType: 'timestamp',
  objectType: 'vehicle',
  blueprint: {},
  get: obj => {
    return obj.created;
  }
};